import RangePicker from './RangePicker';

export default RangePicker;
